// --------------------------------------------------------------------------
// #15 – Content slideshow
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context,
        buttonSvg = '<!--[if gte IE 9]><!-->' + '<svg data-ga="content-slideshow" width="27px" height="23px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26 27" enable-background="new 0 0 26 27" xml:space="preserve">' + '<rect y="13" fill="#ffffff" width="25.3" height="1" />' + '<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" points="12.7,0 24.8,13.5 12.7,27 13.9,27 26,13.5 26,13.5 13.9,0" />' + '</svg>' + '<!--<![endif]-->' + '<!--[if lte IE 8]>' + '<img src="/Static/images/icons/arrow-right-white.png" alt="Right arrow" />' + '<![endif]-->',
        activeClass = 'is-active';

    function showSlideshow(instance, arrows, dots) {
        arrows.add(dots).show();
        instance.addClass(activeClass);
    }

    function hideSlideshow(instance, arrows, dots) {
        arrows.add(dots).hide();
        instance.removeClass(activeClass);
    }

    function setup(instance, jqSlideshow) {
        /**
        * Setup slideshow variables
        */
        var viewSlideshow = instance.data('text-view-slideshow'),
            startSlideShowButton = $('<button class="button" data-ga="content-slideshow"><span class="button__text" data-ga="content-slideshow">' + viewSlideshow + '</span>' + buttonSvg + '</button>'),
            closeSlideshowButton = $('<button class="close-button"><span class="button__text">Close</span></button>');

        /**
         * Initialise slick carousel
         */
        jqSlideshow.slick({
            appendDots: instance,
            dots: true,
            arrows: false
        });

        /**
         * Get number of slides
         */
        var slideCount = jqSlideshow.find('.slick-slide:not(.slick-cloned)').length;

        /**
        * Add start/stop buttons to module
        */
        if (slideCount > 1) {
            instance.append(startSlideShowButton).prepend(closeSlideshowButton);
        }

        /**
         * For initial view - hide arrows and pager dots
         */
        var jqSlideshowArrows = instance.find('.slick-prev, .slick-next'),
            jqSlideDots = instance.find('.slick-dots');

        hideSlideshow(instance, jqSlideshowArrows, jqSlideDots);

        /**
         * On start button click - show arrows and page dots
         */
        startSlideShowButton.on('click', function () {
            $(this).hide();
            showSlideshow(instance, jqSlideshowArrows, jqSlideDots);
        });

        /**
         * On close button click - hide arrows and page dots
         */
        closeSlideshowButton.on('click', function () {
            startSlideShowButton.show();
            hideSlideshow(instance, jqSlideshowArrows, jqSlideDots);
        });
    }

    function init() {
        context.each(function () {
            var instance = $(this);
            var instanceSlide = instance.find('.content-slideshow__list');
            setup(instance, instanceSlide);
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/content-slideshow.js
// module id = 194
// module chunks = 0